import {useEffect, useState} from 'react'
import {collection, doc, onSnapshot} from 'firebase/firestore'
import {useAuth} from 'app/modules/auth'
import db from 'services/firebase'
import {DataroomFile} from '../types/audit.types'

export const useDataroom = () => {
  const {currentUser} = useAuth()
  const [dataroom, setDataroom] = useState<DataroomFile[]>([])

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'dataroom')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const Data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        parentFolder: doc.data().parentFolder || '',
        downloadUrl: doc.data().downloadUrl || '',
        name: doc.data().name || '',
      })) as DataroomFile[]
      setDataroom(Data)
    })

    return unsubscribe
  }, [currentUser])

  return {dataroom}
}